import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function MobileConsultButton() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // 상담 신청 페이지(폼 섹션)에서는 숨김
  const isConsultPage = location.pathname === '/academy';

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (isConsultPage) return null;

  return (
    <>
      {/* 모바일 전용 하단 고정 바 */}
      <div
        className={`md:hidden fixed bottom-0 left-0 w-full z-50 transition-transform duration-300 ${
          visible ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        {/* 상단 그림자 페이드 */}
        <div className="h-4 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" />

        <div className="bg-white border-t border-gray-100 px-4 py-3 flex items-center gap-3">
          {/* 전화 버튼 */}
          <a
            href="tel:010-6740-4061"
            className="whitespace-nowrap flex items-center justify-center gap-2 w-12 h-12 rounded-xl border-2 border-[#1B3A6B] text-[#1B3A6B] flex-shrink-0 cursor-pointer hover:bg-[#1B3A6B]/5 transition-colors"
            aria-label="전화 상담"
          >
            <i className="ri-phone-line text-lg" />
          </a>

          {/* 수강 상담 신청 버튼 */}
          <Link
            to="/academy#consult"
            className="whitespace-nowrap flex-1 flex items-center justify-center gap-2 h-12 rounded-xl bg-[#1B3A6B] text-white font-bold text-sm cursor-pointer hover:bg-[#15305a] transition-colors"
          >
            <i className="ri-edit-line" />
            수강 상담 신청하기
          </Link>

          {/* 카카오 버튼 */}
          <a
            href="https://pf.kakao.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="whitespace-nowrap flex items-center justify-center gap-2 w-12 h-12 rounded-xl bg-[#FEE500] text-[#3A1D1D] flex-shrink-0 cursor-pointer hover:bg-[#f0d800] transition-colors"
            aria-label="카카오톡 상담"
          >
            <i className="ri-kakao-talk-line text-lg" />
          </a>
        </div>

        {/* 아이폰 홈 인디케이터 여백 */}
        <div className="bg-white h-safe-bottom pb-1" />
      </div>

      {/* 모바일 하단 바 높이만큼 여백 (콘텐츠 가림 방지) */}
      <div className={`md:hidden h-20 transition-opacity duration-300 ${visible ? 'opacity-100' : 'opacity-0'}`} />
    </>
  );
}
